import { Flex, OverflowText } from "@theorgchartdev/storybook";
import {
  SanitizeFieldValue,
  IsFieldNotConfigured
} from "@/appComponents/Blocks/Cards/RecordInfoCard/utils";
import ActionListItem from "@/appComponents/Blocks/Composites/ActionListItem/ActionListItem";

export const ProfileTableValue = ({
  fVPair,
  isFavorite,
  onUpdateFavorite,
  enableAdd,
  enableStarring
}) => {
  const { field, value, fieldDef } = fVPair;

  const actions =
    (enableAdd || isFavorite) && enableStarring === true
      ? [
          {
            iconName: isFavorite ? "star-solid" : "star-regular",
            iconProps: {
              color: "brand"
            },
            onClick: () => onUpdateFavorite(fVPair),
            active: isFavorite ?? undefined,
            dataTestId: `profile-add-star-field--${field}`
          }
        ]
      : [];

  const staticTextStyle = {
    minHeight: "15px"
  };

  const notConfigured = IsFieldNotConfigured(value, fieldDef);

  return (
    <Flex direction="column" width="100%" key={field}>
      <ActionListItem
        actions={actions}
        contentBefore={
          <div style={{ width: "100%" }}>
            <OverflowText
              size="xsmall"
              clamp={2}
              style={staticTextStyle}
              dataTestId={`profile-value-row--${field}`}
              colorModifier={notConfigured ? "faintgrey" : undefined}
              modifier={notConfigured ? "italic" : undefined}
            >
              {SanitizeFieldValue(value, fieldDef)}
            </OverflowText>
          </div>
        }
      />
    </Flex>
  );
};
